import { UPDATE_NOTIFICATION_BAR } from 'pages/home/constants';
import { updateNotificationBar } from 'pages/home/home-action';
import { useDispatch, useSelector } from 'react-redux';
import { getNotificationBarInfo } from 'redux/actions/global-actions';
import { actionLoaderSelector, loggedInUserSelector } from 'redux/selectors';

export function useTopNotification({ notificationId }) {
  const isNotificationLoading = useSelector(
    actionLoaderSelector(`${UPDATE_NOTIFICATION_BAR}_${notificationId}`)
  );
  const userInfo = useSelector(loggedInUserSelector);
  const dispatch = useDispatch();
  const updateNotificationStatus = async ({ notificationId = '' }) => {
    let payload = {
      id: notificationId,
      user_id: parseInt(userInfo?.id),
    };
    const status = await dispatch(updateNotificationBar(payload));
    if (status) {
      dispatch(getNotificationBarInfo());
    }
  };
  return {
    updateNotificationStatus,
    isNotificationLoading,
  };
}
